import api from "../../../../../services/api";

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import * as globalComponents from "../../../../../components";
import ListEntry from "../../../components/ListEntry";

import utils from "../../../../../shared/utils.js";

import "../../styles.css";

export default function InternshipOrientations() {
  window.scroll(0, 0);
  const { accessType } = useParams();

  const dir = [
    {
      title: "Serviços Online",
      url: `/${accessType}/servicos-online`,
    },
  ];

  const [data, setData] = useState({
    fisioterapia: [],
    terapia_ocupacional: [],
  });

  useEffect(() => {
    async function fetchData() {
      await api
        .get("/estagio/orientacoes")
        .then((response) => {
          setData(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    fetchData();
  }, []);

  return (
    <>
      <globalComponents.Header />

      <globalComponents.Breadcrumbs
        title="Orientações sobre Estágios"
        dir={dir}
      />

      <div className="container">
        <div className="title__publications">
          <strong>Fisioterapia</strong>

          {data.fisioterapia.map((value, index) => (
            <ListEntry
              key={index}
              title={value.Titulo}
              call={value.Subtitulo}
              href={`/${accessType}/servicos-online/orientacoes-estagios/${utils.slugifyTitle(
                value.Titulo
              )}_${value.Codigo}`}
            />
          ))}
        </div>

        <div className="title__publications">
          <strong>Terapia Ocupacional</strong>

          {data.terapia_ocupacional.map((value, index) => (
            <ListEntry
              key={index}
              title={value.Titulo}
              call={value.Subtitulo}
              href={`/${accessType}/servicos-online/orientacoes-estagios/${utils.slugifyTitle(
                value.Titulo
              )}_${value.Codigo}`}
            />
          ))}
        </div>
      </div>

      <globalComponents.Footer />
    </>
  );
}
